import { api, defaultQueriesFor } from '../apiSlice';

export const locationApi = api
  .enhanceEndpoints({ addTagTypes: ['Location'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'Location', 'Locations', true),

      addLocationSubscriber: build.mutation({
        query: (params) => ({
          url: `/locations/${params.id}/add_subscriber?${new URLSearchParams(params).toString()}`,
          method: 'POST'
        }),
      }),

    }),
  });

export const {
  useAddLocationSubscriberMutation,
  useCreateLocationMutation,
  useDeleteLocationMutation,
  useGetLocationByIdQuery,
  useGetLocationsQuery,
  useUpdateLocationMutation,
} = locationApi;
